import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import { mockData } from '../mock';
import SEO from '../components/SEO';

const Services = () => {
  const { services } = mockData;

  return (
    <div className="services-page">
      <SEO 
        title="Doula Services in Central Georgia | Prenatal, Birth & Postpartum Support"
        description="Comprehensive doula services: prenatal support, labor assistance, postpartum care, herbal consultations, and natural healing. Serving Black mothers in Macon, Warner Robins, Milledgeville & Central GA."
        keywords="doula services Central Georgia, prenatal support Macon, birth doula services, postpartum doula Warner Robins, herbal consultations Georgia, natural healing birth support"
        url="https://georgia-birth-coach.preview.emergentagent.com/services"
      />
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="heading-hero">Services & Support</h1>
          <p className="body-large" style={{maxWidth: '700px', margin: '0 auto'}}>Comprehensive doula care rooted in holistic practices and ancestral wisdom</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section">
        <div className="container">
          <div className="services-grid">
            {services.map((service) => (
              <div key={service.id} className={`service-card ${service.accentClass}`}>
                {service.image && (
                  <div className="service-image-container">
                    <img src={service.image} alt={service.title} className="service-image" />
                  </div>
                )}
                <div className="service-card-header">
                  <h3 className="heading-3">{service.title}</h3>
                  <p className="body-medium">{service.description}</p>
                </div>
                <div className="service-card-details">
                  <ul className="service-list">
                    {service.details.map((detail, index) => (
                      <li key={index} className="service-list-item">
                        <Check size={16} />
                        <span className="body-small">{detail}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Investment Section */}
      <section className="investment-section">
        <div className="container">
          <div className="investment-content">
            <h2 className="heading-2">Investment in Your Journey</h2>
            <p className="body-medium">Each family's needs are unique. During our initial consultation, we'll discuss your specific situation and create a customized care plan that fits your budget and goals.</p>
            <div className="investment-cta">
              <Link to="/contact" className="btn-primary">Schedule Free Consultation</Link>
            </div>
          </div>
        </div>
      </section>

      {/* What to Expect */}
      <section className="expect-section">
        <div className="container">
          <h2 className="heading-1">What to Expect</h2>
          <div className="expect-grid">
            <div className="expect-card">
              <div className="expect-number">01</div>
              <h3 className="heading-3">Initial Consultation</h3>
              <p className="body-small">We'll meet to discuss your birth preferences, health history, and how I can best support you. This is a time to ask questions and ensure we're a good fit.</p>
            </div>
            <div className="expect-card">
              <div className="expect-number">02</div>
              <h3 className="heading-3">Prenatal Visits</h3>
              <p className="body-small">Regular check-ins throughout your pregnancy to build our relationship, prepare for birth, and address any concerns or questions that arise.</p>
            </div>
            <div className="expect-card">
              <div className="expect-number">03</div>
              <h3 className="heading-3">On-Call Support</h3>
              <p className="body-small">Available by phone or text as your due date approaches, and continuous in-person support during labor and birth.</p>
            </div>
            <div className="expect-card">
              <div className="expect-number">04</div>
              <h3 className="heading-3">Postpartum Care</h3>
              <p className="body-small">Follow-up visits to check on your recovery, support breastfeeding, and help you transition into motherhood with confidence.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
